import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, accountStatus, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/accueil" replace />;
  }

  if (accountStatus && accountStatus !== 'valide') {
    return <Navigate to="/en-attente-validation" replace />;
  }

  return children;
};

export default ProtectedRoute;